export default __webpack_public_path__ + "static/media/PFMFunds_Site_Logo.003de9ce.png";